import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    TransportListItem,
    TransportOrTransportPlan, TransportState as TransportStateEnum
} from "../../../models/transport/transport";
import { fetchTransports, transportToCommonTransportModel } from "../../../services/transportService";
import { Session } from "../../session/session";

export interface TransportState {
    activeTransports: TransportOrTransportPlan[],
}

const initialState: TransportState = {
    activeTransports: null,
};

export const transportSlice = createSlice({
    name: "transport",
    initialState,
    reducers: {
        setActiveTransports: (state, action: PayloadAction<TransportListItem[]>) => {
            state.activeTransports = action.payload.map(transportToCommonTransportModel);
        },
        removeActiveTransport: (state, action: PayloadAction<string>) => {
            state.activeTransports = state.activeTransports.filter(tp => tp.transportPlanId !== action.payload);
        },
    },
});

export const {
    setActiveTransports,
    removeActiveTransport,
} = transportSlice.actions;

export const fetchActiveTransports = createAsyncThunk(
    "transportPlan/active/fetch",
    async(_, thunkApi) => {
        const employeeId = (await Session.getSessionState()).id;
        const plans = (await fetchTransports({
            state: TransportStateEnum.InTransport,
            employeeId: employeeId,
        })).data;
        thunkApi.dispatch(setActiveTransports(plans));
    }
);

export const transportReducer = transportSlice.reducer;
